import { observable, runInAction } from 'mobx';

import config from '../config';
import AuthedStore from './AuthedStore';

export class OrganisationStore extends AuthedStore {
    @observable loading: boolean;

    async getList() {
        this.loading = true;
        const res = await fetch(config.API_ENDPOINT + '/user/org/', {
            headers: this.getHeaders(),
            method: 'GET',
        });

        const json = await res.json();
        runInAction(() => {
            this.loading = false;
        });

        if (!res.ok) {
            return Promise.reject(new Error(json));
        }

        return Promise.resolve(json);
    }

    async getUsers(orgId: string) {
        this.loading = true;
        const res = await fetch(config.API_ENDPOINT + `/user/org/${orgId}/users/`, {
            headers: this.getHeaders(),
            method: 'GET',
        });

        const json = await res.json();
        runInAction(() => {
            this.loading = false;
        });

        if (!res.ok) {
            return Promise.reject(new Error(json));
        }

        return Promise.resolve(json);
    }

    async sendInvites(orgId: string, emails: string) {
        this.loading = true;
        const res = await fetch(config.API_ENDPOINT + `/user/add_users/`, {
            headers: this.getHeaders(),
            method: 'POST',
            body: JSON.stringify({ org_id: orgId, emails: emails.split(',') }),
        });

        const json = await res.json();
        runInAction(() => {
            this.loading = false;
        });

        if (!res.ok) {
            return Promise.reject(new Error(json));
        }

        return Promise.resolve(json);
    }
}

export default new OrganisationStore;



// WEBPACK FOOTER //
// ./src/stores/OrganisationStore.ts